{
  "jobLabel": "Swydd",
  "close": "Cau",
  "cancel": "Canslo",
  "cancelled": "Canslwyd",
  "onHold": "Wedi'i ohirio",
  "ok": "Iawn",
  "allow": "Caniatáu",
  "confirm": "Cadarnhau",
  "dismiss": "Diystyru",
  "pleaseWait": "Arhoswch os gwelwch yn dda...",
  "about": "Ynghylch",
  "version": "Fersiwn",
  "callUs": "Ffoniwch ni",
  "emailUs": "E-bostiwch ni",
  "privacyPolicy": "Polisi Preifatrwydd",
  "termsOfService": "Telerau Gwasanaeth",
  "profile": "Proffil",
  "contact": "Cyswllt",
  "editProfile": "Golygu proffil",
  "menu": "Dewislen",
  "paymentCards": "Cardiau talu",
  "address": "Cyfeiriad",
  "pointOfInterest": "Man o Ddiddordeb",
  "myAddresses": "Fy nghyfeiriadau",
  "operatorLogo": "Logo'r gweithredwr",
  "search": "Chwilio",
  "goodsTypes": {
    "passenger": "Teithiwr",
    "passengers": "1 teithiwr | {count} teithiwr",
    "parcel": "Parsel",
    "parcels": "1 parsel | {count} parsel",
    "pallet": "Paled",
    "pallets": "1 paled | {count} paled",
    "internationalParcel": "Parsel Rhyngwladol",
    "internationalParcels": "1 parsel rhyngwladol | {count} parsel rhyngwladol",
    "overnightParcel": "Parsel Dros Nos",
    "overnightParcels": "1 parsel dros nos | {count} parsel dros nos",
    "good": "Nwydd",
    "goods": "1 nwydd | {count} nwydd"
  },
  "bags": "1 bag | {count} o fagiau",
  "cartons": "1 carton | {count} o gartonau",
  "newBooking": {
    "title": "Archeb newydd",
    "button": "Archeb newydd"
  },
  "editBooking": "Golygu archeb",
  "errorOccured": "Mae gwall wedi digwydd - rhowch gynnig arall",
  "errorCalculatingRoute": "Gwall wrth gyfrifo'r llwybr",
  "addStop": "Ychwanegu stop",
  "searchAddress": "Chwilio cyfeiriad",
  "addressTypes": "Mathau o gyfeiriadau",
  "noBookingDetails": "Dim manylion archeb ar gael",
  "pickupDelay": "{dateString} (~{delay} munud)",
  "performingQuote": "Yn cyfrifo dyfynbris",
  "n/a": "Dim ar gael",
  "approx": "tua",
  "est": "Amc.",
  "earliest": "Cynharaf {dt}",
  "pickup": "Casglu {dt}",
  "arrive": "Cyrraedd {dt}",
  "back": "",
  "areYouSure": "Ydych chi'n siŵr?",
  "alertBack": "Yn ôl",
  "lastRefreshed": "Diweddarwyd ddiwethaf: ",
  "storedAddressLabel": "Cyfeiriadau",
  "deleteAddress": "Dileu cyfeiriad",
  "noStoredAddressDetails": "Dim cyfeiriadau ar gael",
  "alertFilter": "Hidlo",
  "alertYourAddresses": "Eich cyfeiriadau",
  "alertAccountAddresses": "Cyfeiriadau cyfrif",
  "alertRecentAddresses": "Cyfeiriadau diweddar",
  "groupYourAddresses": "Eich cyfeiriadau",
  "groupAccountAddresses": "Cyfeiriadau cyfrif",
  "groupRecentAddresses": "Cyfeiriadau diweddar",
  "buttonAddressBookFrom": "Archebu o...",
  "buttonAddressBookTo": "Archebu i...",
  "buttonAddressEdit": "Golygu",
  "mapSearch": "Chwilio map",
  "noAddressesFound": "Dim cyfeiriadau wedi'u canfod",
  "noCountriesFound": "Dim gwledydd wedi'u canfod",
  "save": "Cadw",
  "remove": "Tynnu",
  "signOutConfirmation": "Ydych chi am allgofnodi?",
  "exitAppConfirmation": "Ydych chi am adael yr ap?",
  "minute": "mun",
  "hour": "awr",
  "booking": "Archeb",
  "noBookingTemplates": "Dim templedi archeb ar gael",
  "reporting": {
    "title": "Adroddiadau",
    "selectReport": "Dewis adroddiad",
    "updateReportButton": "Diweddaru adroddiad",
    "noReportsAvailable": "Dim adroddiadau ar gael",
    "noReportSelected": "Dim adroddiad wedi'i ddewis",
    "filters": "Hidlau adroddiad",
    "export": {
      "copy": "Copïo",
      "csv": "CSV",
      "xls": "Excel",
      "pdf": "PDF"
    }
  },
  "actions": "Gweithredoedd",
  "noMop": "Dim dulliau talu ar gael",
  "flightSearch": {
    "title": "Chwilio hediadau",
    "addFlightDetails": "Ychwanegu manylion hediad",
    "noFlightsFound": "Dim hediadau wedi'u canfod",
    "flightWarning": "Rhybudd hediad",
    "airportArriveWarningMessage": "Gwiriwch y hediad a ddewiswyd, nid ydym yn credu ei fod yn cyrraedd y maes awyr a ddewiswyd gennych",
    "airportDepartWarningMessage": "Gwiriwch y hediad a ddewiswyd, nid ydym yn credu ei fod yn gadael o'r maes awyr a ddewiswyd gennych",
    "terminalArriveWarningMessage": "Gwiriwch y hediad a ddewiswyd, nid ydym yn credu ei fod yn cyrraedd y derfynfa a ddewiswyd gennych",
    "terminalDepartWarningMessage": "Gwiriwch y hediad a ddewiswyd, nid ydym yn credu ei fod yn gadael o'r derfynfa a ddewiswyd gennych",
    "matchFlightTimeHeader": "Cydweddu amser hediad?",
    "matchFlightTimeMessage": "A hoffech gydweddu amser yr archeb ag amser cyrraedd yr hediad?",
    "selectedAirport": "Maes awyr a ddewiswyd: {airportCode}",
    "flightAirport": "Maes awyr yr hediad: {airportCode}",
    "flightTerminal": "Terfynfa'r hediad: {terminal}",
    "searchButton": "Chwilio am hediadau"
  },
  "to": "i",
  "from": "o",
  "noContactsFound": "Dim cysylltiadau wedi'u canfod",
  "maintainContact": "Cynnal cyswllt",
  "bookAs": "Archebu fel",
  "leadPassenger": "Prif deithiwr",
  "bookAsWarning": "I gwblhau'r archeb hon byddwch yn newid i archebu fel {contactName}",
  "webAccess": {
    "addJobsMessage": "Nid oes gennych hawliau mynediad i greu archeb newydd, ffoniwch {companyTelephoneNumber}",
    "editJobsMessage": "Nid oes gennych hawliau mynediad i olygu'r archeb hon, ffoniwch {companyTelephoneNumber}",
    "cancelJobsMessage": "Nid oes gennych hawliau mynediad i ganslo'r archeb hon, ffoniwch {companyTelephoneNumber}",
    "addCardsMessage": "Nid oes gennych hawliau mynediad i ychwanegu cardiau talu, ffoniwch {companyTelephoneNumber}",
    "editContactsMessage": "Nid oes gennych hawliau mynediad i olygu'r cyswllt hwn, ffoniwch {companyTelephoneNumber}",
    "addAddressesMessage": "Nid oes gennych hawliau mynediad i ychwanegu cyfeiriadau, ffoniwch {companyTelephoneNumber}",
    "editAddressesMessage": "Nid oes gennych hawliau mynediad i olygu cyfeiriadau, ffoniwch {companyTelephoneNumber}",
    "deleteAddressesMessage": "Nid oes gennych hawliau mynediad i ddileu cyfeiriadau, ffoniwch {companyTelephoneNumber}",
    "canRequestMessage": "Nid oes gennych hawliau mynediad i ofyn am fynediad cyswllt, ffoniwch {companyTelephoneNumber}"
  },
  "approved": "Cymeradwywyd",
  "contactLink": {
    "contactLink": "Cyswllt cyswllt",
    "linkNewContact": "Cysylltu cyswllt newydd",
    "linkedContacts": "Cysylltiadau cysylltiedig",
    "noLinkedContacts": "Dim cysylltiadau cysylltiedig",
    "pendingLinkedContacts": "Cysylltiadau cysylltiedig sy'n aros",
    "noPendingLinkedContacts": "Dim cysylltiadau cysylltiedig sy'n aros",
    "authoriseContactLink": "Awdurdodi cysylltiad?",
    "confirmOrRejectContactLink": "A ydych am gadarnhau neu wrthod y cysylltiad hwn?",
    "description": "Angen gwneud archebion ar ran cydweithiwr, neu gynnal ei broffil? Gofynnwch am fynediad drwy nodi ei gyfeiriad e-bost isod. Bydd yn derbyn hysbysiad eich bod yn dymuno cael mynediad i'w broffil.",
    "pending": "Yn aros",
    "reject": "Gwrthod"
  },
  "jobCalendar": {
    "eventTitle": "{companyName}: {firstStop} i {lastStop}",
    "pickup": "Codi: {address}",
    "via": "Drwy: {address}",
    "dropOff": "Gollwng: {address}",
    "journeyTime": "Amser teithio amcangyfrifedig: {duration}",
    "trackingLink": "Dilynwch eich taith: {url}"
  },
  "jobSharing": {
    "shareRideDetails": "Rhannu manylion y daith",
    "iAm": "Rwyf yn",
    "personIs": "Mae {person} yn",
    "shareMessage": "yn teithio gyda {companyName} o {firstStop} i {lastStop} ar {dt}"
  },
  "noEditAccess": "Dim hawl i olygu",
  "noBookingAccess": "Dim mynediad i archeb",
  "invalidBooking": "Manylion archeb annilys",
  "adminConsole": "Consol gweinyddol",
  "cookieConsent": {
    "message": "Rydym yn defnyddio cwcis i wella eich profiad a darparu gwasanaethau hanfodol. Drwy barhau i bori ein gwefan, rydych yn cydsynio i ddefnyddio cwcis. Am ragor o wybodaeth, darllenwch ein",
    "privacyPolicy": "Polisi preifatrwydd",
    "accept": "Derbyn",
    "dismiss": "Cau"
  },
  "eta": "ETA: {eta}",
  "settings": "Gosodiadau",
  "language": "Iaith",
  "appearance": {
    "label": "Gwedd",
    "system": "System",
    "light": "Golau",
    "dark": "Tywyll"
  },
  "bookingButtons": {
    "addFavourite": "Ychwanegu ffefryn",
    "clearFavourite": "Clirio ffefryn",
    "edit": "Golygu",
    "share": "Rhannu",
    "sendConfirmation": "Anfon cadarnhad",
    "copy": "Copïo",
    "return": "Dychwelyd",
    "cancel": "Canslo",
    "addToCalendar": "Ychwanegu at y calendr",
    "more": "Rhagor"
  },
  "date": "Dyddiad",
  "time": "Amser",
  "price": {
    "taxIncluded": "(Yn cynnwys {tax} TAW)",
    "saving": "Arbediad o {amount}"
  },
  "distance": {
    "outputText": "Pellter {distance}",
    "extraText": "Sylwer mai amcangyfrifon yn unig yw pellteroedd teithiau",
    "metresAway": "{distance} metr i ffwrdd",
    "kilometresAway": "{distance} km i ffwrdd",
    "feetAway": "{distance} troedfedd i ffwrdd",
    "milesAway": "{distance} milltir i ffwrdd",
    "miles": "{distance} milltir | {distance} milltir",
    "kilometres": "{distance} km"
  },
  "journey": {
    "outputText": "Taith {journey}",
    "extraText": "Sylwer mai amcangyfrifon yn unig yw amseroedd teithiau"
  },
  "betweenTwoStrings": "Rhwng {first} a {second}",
  "quickQuote": "Dyfynbris",
  "bookingConfirmation": {
    "newTitle": "Archeb wedi'i chadarnhau",
    "editTitle": "Archeb wedi'i golygu",
    "navigationCountdown": "Yn cau mewn { secondsRemaining }s",
    "navigateButton": "Gweld / Rheoli archeb"
  },
  "savedJourneys": {
    "favTitle": "Teithiau ffefryn",
    "noFavsMessage": "Dim teithiau ffefryn ar gael",
    "recentTitle": "Teithiau diweddar",
    "noRecentsMessage": "Dim teithiau diweddar ar gael",
    "stopsHeader": "Taith",
    "tariffHeader": "Gwasanaeth",
    "goodsHeader": "Nwyddau",
    "alert": {
      "addHeader": "Ychwanegu'r daith hon fel ffefryn?",
      "addMessage": "Ychwanegwch ddisgrifiad dewisol o'r daith",
      "editHeader": "Golygu disgrifiad",
      "editMessage": "Golygwch y disgrifiad dewisol o'r daith",
      "descriptionPlaceholder": "Disgrifiad"
    }
  },
  "location": {
    "permissionMessage": "I'n galluogi i ganfod eich lleoliad presennol, caniatewch fynediad"
  },
  "documents": "Dogfennau",
  "goodsFields": {
    "unitWeight": "Pwysau",
    "unitHeight": "Uchder",
    "unitWidth": "Lled",
    "unitDepth": "Dyfnder",
    "unitValue": "Gwerth",
    "unitCube": "Ciwb",
    "palletType": "Math o Baled",
    "palletSubType": "Is-fath o Baled",
    "nonDoc": "Nad yw'n Ddogfen",
    "volumetricWeight": "Pwysau cyfeintiol"
  },
  "viewBooking": {
    "guestInfo": "Gwybodaeth am y Gwestai",
    "parcelInfo": "Gwybodaeth am y Parsel",
    "palletInfo": "Gwybodaeth am y Paled",
    "journeyRouteMessage": "Mae'r map yn dangos llwybr enghreifftiol yn unig ac efallai nad dyma'r union lwybr y bydd y gyrrwr yn ei ddilyn ar eich taith.",
    "jobFlags": "Opsiynau",
    "jobExtras": "Ychwanegion",
    "jobRefs": "Cyfeiriadau",
    "driverPhoto": "Llun y gyrrwr",
    "vehicleImage": "Llun y cerbyd",
    "tariffImage": "Llun y gwasanaeth",
    "proofOfDelivery": "Prawf danfon",
    "webInstructions": "Nodiadau i'r Gyrrwr",
    "price": "Pris",
    "netPrice": "Pris Net",
    "tax": "TAW",
    "totalPrice": "Cyfanswm y Pris"
  },
  "dateRelative": {
    "lastWeek": "eeee 'diwethaf am' p",
    "yesterday": "'Ddoe am' p",
    "today": "'Heddiw am' p",
    "tomorrow": "'Yfory am' p",
    "nextWeek": "eeee 'am' p",
    "other": "P 'am' p"
  },
  "payment": {
    "cards": "Cardiau Talu",
    "noCards": "Dim cardiau talu ar gael",
    "bookingPaymentTitle": "Taliad Archebu",
    "withCardEnding": "gyda cherdyn yn gorffen {cardNum}",
    "cardValidFrom": "dilys o",
    "cardValidTo": "dilys tan",
    "addCard": "Ychwanegu Cerdyn",
    "deleteCard": "Dileu Cerdyn",
    "makeDefaultCard": "Gwneud yn gerdyn diofyn",
    "pay": "Talu",
    "savedCards": "Cardiau wedi'u Cadw",
    "otherPaymentMethod": "Dull Arall",
    "adflexNavWarning": "Os ydych eisoes wedi gwneud taliad, byddwch yn dal i gael eich codi"
  },
  "profileContact": {
    "telephone": "Ffôn",
    "mobile": "Ffôn symudol",
    "account": "Cyfrif"
  }
}
